<template>
    <!--        :props="propsOptions"-->
    <el-cascader
        ref="cascader"
        class="w100p"
        :value="data"
        :options="dataList"
        :props="cascaderProps"
        clearable
        :filterable="filterable"
        :collapse-tags="collapseTags"
        :show-all-levels="showAllLevels"
        :placeholder="placeholder || $t('请选择')"
        :size="size"
        :disabled="disabled"
        @change="handleChange"
    />
</template>

<script>
export default {
    name: 'Cascader',
    props: {
        data: {},
        placeholder: {
            type: String
        },
        dataList: {
            type: Array,
            default: () => {
                return []
            }
        },
        collapseTags: {
            type: Boolean,
            default: true
        },
        showAllLevels: {
            type: Boolean,
            default: true
        },
        filterable: {
            type: Boolean,
            default: true
        },
        cascaderProps: {
            type: Object,
            default: () => {
                return {
                    label: 'label',
                    children: 'children',
                    value: 'value'
                }
            }
        },
        size: {
            default: 'small'
        },
        disabled: {
            default: false
        }
    },
    data() {
        return {}
    },
    methods: {
        handleChange(val) {
            const nodes = this.$refs.cascader.getCheckedNodes(true)
            this.$emit('change', {
                ids: val,
                nodes
            })
        }
    }
}
</script>

<style lang="stylus"
       scoped
>

::v-deep .el-cascader__tags .el-tag {
    border-radius: 0;
    background-color: $--color-bg;
    margin: 2px 8px !important;
    & > span {
        color: $--color-primary;
    }
}
</style>
